import { mentees as initialState } from '../initialStates';
import * as types from '../../action-types';

const mentees = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case types.MENTEES_START:
            return {
                ...state,
                isLoading: true,
            }
        case types.MENTEES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSuccessful: true,
                data: payload
            }
        case types.MENTEES_FAIL:
            return {
                ...state,
                isLoading: false,
                error: payload
            }
        case types.MENTEES_CLEANUP:
            return {
                ...state,
                data: null,
                error: null,
                isSuccessful: false,
            }
        default:
            return state;
    };
};

export default mentees;
